module.exports = __webpack_public_path__ + "static/media/vip2.d58d5cf3.png";